__turbopack_context__.v({
  "headerWrapper": "customers-module-scss-module__bUmzeq__headerWrapper",
});
